import { Component, OnInit, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { DropzoneConfigInterface, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { EmployeeService } from 'src/app/core/services/employee.service';

declare var $: any;
declare var libphonenumber: any;

@Component({
    selector: 'app-employee-file-upload',
    templateUrl: './employee-file-upload.component.html',
    styleUrls: ['./employee-file-upload.component.css']
})
export class EmployeeFileUploadComponent implements OnInit {

    @Output() completeCallback = new EventEmitter<any>();
    @ViewChild('viewSkillsSampleFormat') viewSkillsSampleFormatRef: TemplateRef<any>;
    @ViewChild(DropzoneDirective) fileUploadDropZone: DropzoneDirective;
    showFileFormatModal: BsModalRef;

    uploadEmployeeFileResponse: any;
    employeeList: any = [];
    candidatesToAssociateList: any = [];
    fileFormatModal: any;
    uploadFileWizard: any;
    dropzoneConfig: DropzoneConfigInterface;

    isFileUploaded: boolean = false;
    disableUploadButtonFlag: boolean = true;
    fileExistsFlag: boolean = false;
    disablePreviousButtonFlag: boolean = false;
    disableNextButtonFlag: boolean = true;
    fileUploadInProgressFlag: boolean = false;
    mandatoryFieldsError: boolean = false;
    isStaffingCompany: boolean;

    constructor(
        private companyService: CompanyService,
        private alertsAndNotificationsService: AlertAndNotificationsService,
        private employeeService: EmployeeService,
        private authService: AuthService,
        private $state: StateService,
        public bsModalService: BsModalService
    ) { }

    ngOnInit() {
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        // wait for changes to take effect and then create wizard
        setTimeout(() => {
            //create the wizard
            this.uploadFileWizard = this.createFileUploadWizard();
        }, 200);
        this.dropzoneConfig = this._getDropZoneSettings();
    }

    /**
       * create the wizard for the upload resume workflow
       */
    createFileUploadWizard() {
        let uploadFileWizard = $("#uploadFileWizard").wizard();

        $('#uploadFileWizard').on('actionclicked.fu.wizard', (evt, data) => {
            if (data.direction == "next") {
                switch (data.step) {
                    case 1:
                        // remove the remove button from the file.
                        $('.dz-remove').remove();
                        break;
                    case 2:
                        // do nothing
                        // complete click
                        // handled in finish event
                        break;
                    default:
                        break;
                }
            } else if (data.direction == "previous") {
                switch (data.step) {
                    case 1:
                        // not possible
                        break;
                    case 2:
                        this.updateActionButtons();
                        break;
                    default:
                        break;
                }
            }
        });

        $('#uploadFileWizard').on('finished.fu.wizard', (evt, data) => {
            if (this.completeCallback) {
                this.completeCallback.emit();
            }
        });

        return uploadFileWizard;
    }

    onFileAdded(file) {
        this.fileExistsFlag = true;
        this.updateActionButtons();
        const progressElement: HTMLElement = document.querySelector('.dz-progress');
        if (progressElement) {
            progressElement.style.top = '70%';
        }
    }

    onFileRemoved(file) {
        if (this.fileUploadDropZone.dropzone().files.length === 0) {
            this.fileExistsFlag = false;
            // enable adding of further files if it was disabled
            const hiddenInput: HTMLInputElement = document.querySelector('.dz-hidden-input');
            if (hiddenInput) {
                hiddenInput.disabled = false;
            }
        }
        this.updateActionButtons();
    }

    onFileSending() {
        // disable the upload button to avoid multiple clicks
        this.disableUploadButtonFlag = true;
        this.isFileUploaded = false;
        // indicate that file upload is in progress
        this.fileUploadInProgressFlag = true;
    }

    onFileSuccess(args) {
        const response = args[1];
        // remove file upload in progress flag
        this.fileUploadInProgressFlag = false;
        this.isFileUploaded = true;

        this.alertsAndNotificationsService.showBannerMessage('Employee file uploaded successfully', 'success');
        // merge the response into the job object
        this._setEmployees(response);
        this.updateActionButtons();
        // disable adding of further files
        const hiddenInput: HTMLInputElement = document.querySelector('.dz-hidden-input');
        if (hiddenInput) {
            hiddenInput.disabled = true;
        }
    }

    onFileError(args) {
        const file = args[0];
        const error = args[1];
        const elements = document.querySelectorAll('.dz-file-preview');
        Array.from(elements).forEach((element) => {
            const filename = element.querySelectorAll('.dz-filename span')[0].textContent;
            const errorMessage = element.querySelectorAll('.dz-error-message span')[0];
            if (filename === file.name) {
                errorMessage.textContent = error.message === undefined ? error : error.message;
            }
        });
    }

    _getDropZoneSettings(): DropzoneConfigInterface {
        let dropZoneSettings = {};
        dropZoneSettings = {
            url: this.employeeService.getUploadEmployeesUrl() + '/' + this.authService.getUserDetails().company.companyId,
            paramName: () => {
                return "file";
            },
            acceptedFiles: ".csv,.xlsx",
            maxFiles: 1,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            timeout: 300000,
            addRemoveLinks: true,
            autoProcessQueue: false,
            uploadMultiple: false
        }
        return dropZoneSettings;
    }

    _setEmployees(employeesResponse) {
        this.employeeList = employeesResponse;
        angular.forEach(this.employeeList, (employee, key) => {
            if (_.isNull(employee.employeeDTO.firstName) || employee.employeeDTO.firstName == "") {
                employee.employeeDTO.firstName = "-";
            }
            if (_.isNull(employee.employeeDTO.lastName) || employee.employeeDTO.lastName == "") {
                employee.employeeDTO.lastName = "-";
            }
            if (_.isNull(employee.employeeDTO.email) || employee.employeeDTO.email == "") {
                employee.employeeDTO.email = "-";
            }
            if (_.isNull(employee.employeeDTO.phoneNumber) || employee.employeeDTO.phoneNumber.trim() == "") {
                employee.employeeDTO.phoneNumber = "-";
            }
            if (_.isNull(employee.employeeDTO.title) || employee.employeeDTO.title == "") {
                employee.employeeDTO.title = '-';
            }
            employee.employeeDTO.name = employee.employeeDTO.firstName + ' ' + employee.employeeDTO.lastName;
            if (employee.employeeDTO.phoneNumber.startsWith("+")) {
                let phoneNumberObject = libphonenumber.parse(employee.employeeDTO.phoneNumber.toString());
                if (phoneNumberObject.phone !== undefined) {
                    employee.employeeDTO.phoneNumber = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
                }
            }
            if (_.isNull(employee.employeeDTO.buName) || employee.employeeDTO.buName == "") {
                employee.employeeDTO.buName = '-';
            }
            if (_.isNull(employee.employeeDTO.organizationManagerName) || employee.employeeDTO.organizationManagerName == "") {
                employee.employeeDTO.organizationManagerName = '-';
            }
            if (this.isStaffingCompany) {
                employee.departmentName = "-";
                if (!_.isNull(employee.employeeDTO.department)) {
                    employee.departmentName = employee.employeeDTO.department.name;
                }
            }

            let message = "";
            angular.forEach(employee.messages, (responseMessage, key) => {
                if (key == 0) {
                    message = responseMessage;
                } else {
                    message = message + ". " + responseMessage;
                }
            });
            employee.message = message;
            // enable previous and next (complete) button after processing
            this.disableNextButtonFlag = false;
            this.disablePreviousButtonFlag = false;
        });
    }

    /**
     * update the action buttons
     */
    updateActionButtons() {
        let wizardCurrentStep = $('#uploadFileWizard').wizard('selectedItem').step;
        switch (wizardCurrentStep) {
            case 1:
                // if resumes exist and upload completed, then the functions on this tab are disabled.
                if (this.isFileUploaded) {
                    this.fileUploadDropZone.dropzone().clickable = false;
                    this.disableUploadButtonFlag = true;
                    this.disableNextButtonFlag = false;
                } else {
                    // in else because no resumes have been uploaded yet
                    if (this.fileExistsFlag) {
                        // if files exist in drop zone
                        this.disableUploadButtonFlag = false;
                    } else {
                        // files do not exist in drop zone
                        this.disableUploadButtonFlag = true;
                        // this.disableSourceTypesFlag = false;
                    }
                    // disable the next button
                    this.disableNextButtonFlag = true;
                }
                break;
            case 2:
                break;
            default:
                break;
        }
    }

    uploadEmployeeFile() {
        this.fileUploadDropZone.dropzone().processQueue();
    }

    showFileFormat(template: TemplateRef<any>) {
        const config = new ModalConfig();
        const modalData: any = {};
        config.class = "modal-lg custom-ngx-modal";
        config.initialState = modalData;
        this.showFileFormatModal = this.bsModalService.show(template, config);
    }

    wizardCancel() {
        this.$state.go("missioncontrol.employees");
    }

    closeFileFormateModal() {
        if (this.showFileFormatModal) {
            this.showFileFormatModal.hide();
        }
    }

}
